module.exports = __webpack_public_path__ + "img/systemComponentsHierarchies.74f081a9.svg";